import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Stack, Tooltip, Typography } from "@mui/material";

import HomePageCard from "../HomePageCard";

export const CreateItemCard = ({
  createMsg,
  buttonLabel,
  title,
  onButtonClick,
  buttonDataCy,
  disabled,
}: {
  createMsg: string;
  buttonLabel: string;
  title: string | React.ReactNode;
  onButtonClick: () => void;
  buttonDataCy: string;
  disabled: boolean;
}) => {
  const history = useHistory();

  return (
    <HomePageCard title={title}>
      <Stack direction="column" spacing={3} sx={{ p: 3, height: 177 }}>
        <Typography
          variant="caption"
          color="text.primary"
          sx={{ textTransform: "lowercase", "&:first-letter": { textTransform: "capitalize" } }}
        >
          {createMsg}
        </Typography>
        <Tooltip
          title={
            disabled ? "You don't have the correct permissions to perform this action. Please contact your admin." : ""
          }
        >
          <span>
            <Button
              variant="outlined"
              size="small"
              sx={{ alignSelf: "flex-start", "@media print": { display: "none" } }}
              endIcon={<ArrowForwardIcon />}
              onClick={onButtonClick}
              data-cy={buttonDataCy}
              disabled={disabled}
            >
              {buttonLabel}
            </Button>
          </span>
        </Tooltip>

        <Button
          variant="text"
          size="small"
          sx={{ alignSelf: "flex-start", "@media print": { display: "none" } }}
          data-cy="get-help-btn"
          onClick={() => {
            history.push("./support?open-case-iq=true");
          }}
        >
          Get help from our human experts
        </Button>
      </Stack>
    </HomePageCard>
  );
};
